module.exports = __webpack_public_path__ + "static/avatar-71a9d9ece9b22efc1d9a9c4fd51db835.png";